export const en = {
    copied: 'Copied',
    'copy-error': 'Error copying',
    'copy-link': 'Copy criteria to the clipboard',
    metrikaAudience: 'Yandex.Audience and Yandex.Metrica',
    'open-popup-text': 'View impression criteria',
    'popup-title': 'Impression criteria',
    'users-profiles': 'User profile'
};
